export type ProviderName = "FINATIC";

export interface CheckoutResponse {
    provider: ProviderName;
    amount: number;
    payload: any;
}

export function launchProviderCheckout(resp: CheckoutResponse) {


    if (!resp) throw new Error("Empty checkout response");

    if (resp.amount == 0) {
        const url = resp.payload.return_url;
        if (!url) throw new Error("Missing return URL for zero-amount order");
        window.location.assign(url);
        return;
    }

    switch (resp.provider) {
        case "FINATIC": {
            const url = resp.payload.url;
            if (!url) throw new Error("Missing Finatic checkout URL");
            window.location.assign(url);
            return;
        }
    }
}
